import React from "react";
import { Link } from "react-router-dom";

const CreateBooking = () => (
  <Link
    className=" btn btn-primary btn-sm tw-min-w-max mb-1"
    style={{ textDecoration: "none", color: "white" }}
    to="/vacancies/create-options"
  >
    New Vacancy
  </Link>
);

export default CreateBooking;
